/** Where a station's data comes from, in the board's second line: Home's
 *  table and a project's station list. */
import type { Station } from '../api/types'
import { duration } from './health'

export function sourceDetail(station: Station): string {
  const every = duration(station.poll_interval_s * 1000)
  if (station.vendor === 'cmt_edge') return `Network ${station.external_id}`
  if (station.vendor === 'mrl_push') return `Direct push, ${every}`
  return `Through MDS, ${every}`
}
